import React from 'react';
import swal from 'sweetalert';
import { Loader2 } from 'lucide-react';
import i18n from '../../../../../i18n';
import { checkDiscountEligibility, applyDiscount } from '../services/auctionApprovalServices';
import { CustomModal } from '../../../../common/CustomModal';

export class AuctionDiscountModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      checking: false,
      eligibility: null,
      remarks: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show && this.props.auction) {
      this.checkEligibility();
    }
  }

  checkEligibility = async () => {
    const { auction } = this.props;
    if (!auction) return;

    this.setState({ checking: true, eligibility: null });
    try {
      const response = await checkDiscountEligibility({
        user: auction.user_id,
        group: auction.group_id,
      });
      if (response && response.success) {
        this.setState({ eligibility: response.data });
      } else {
        this.setState({ eligibility: { eligible: false, reason: 'error' } });
      }
    } catch (err) {
      console.error(err);
      this.setState({ eligibility: { eligible: false, reason: 'error' } });
    } finally {
      this.setState({ checking: false });
    }
  };

  getReasonMessage = (reason) => {
    const messages = {
      not_staff: 'This user is not eligible for staff discounts.',
      already_used_in_group: 'This employee already used their discount in this group.',
      yearly_limit_reached: 'This employee has already used 2 discounts this year.',
      no_wins_in_group: 'This employee has no winning auctions in this group.',
      error: 'Could not check discount eligibility.',
    };
    return messages[reason] || 'Not eligible for a discount.';
  };

  async handleSubmit(event) {
    event.preventDefault();
    const { auction } = this.props;
    const { eligibility, remarks } = this.state;

    if (!eligibility || !eligibility.eligible) return;

    this.setState({ loading: true });
    try {
      const response = await applyDiscount({
        user: auction.user_id,
        group: auction.group_id,
        auction: eligibility.auction_id,
        remarks,
      });

      if (response && response.success) {
        swal(i18n.t('success'), 'Discount applied successfully', 'success');
        if (this.props.onSuccess) {
          this.props.onSuccess();
        } else {
          this.props.onClose();
        }
      } else {
        swal(i18n.t('failed'), response.message, 'error');
      }
    } catch (err) {
      console.error(err);
      swal(i18n.t('failed'), 'Something went wrong applying the discount', 'error');
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const { show, onClose, auction } = this.props;
    const { checking, eligibility, loading, remarks } = this.state;

    return (
      <CustomModal isOpen={show} header="Apply Staff Discount" onClose={onClose}>
        <div className="wallet-form-container">
          {checking && (
            <div className="stats-section-center">
              <Loader2 className="animate-spin" size={20} />
              <span style={{ marginLeft: 8 }}>Checking eligibility...</span>
            </div>
          )}

          {!checking && eligibility && !eligibility.eligible && (
            <div className="wallet-error" style={{ padding: '12px 0' }}>
              {this.getReasonMessage(eligibility.reason)}
            </div>
          )}

          {!checking && eligibility && eligibility.eligible && (
            <form className="wallet-form" autoComplete="off">
              <div className="stats-section-center">
                <div className="stat-box-center">
                  <div className="stat-label-center">Winning Bid</div>
                  <div className="stat-value-center">{eligibility.bid_amount} OMR</div>
                </div>
                <div className="stat-box">
                  <div className="stat-label-center">Discount ({eligibility.discount_percentage}%)</div>
                  <div className="stat-value-center amount">-{eligibility.discount_amount} OMR</div>
                </div>
              </div>

              <div className="wallet-form-content">
                <p style={{ fontSize: 13, color: '#666' }}>
                  {eligibility.remaining_this_year} of 2 yearly discounts remaining for this
                  employee after this one. Auction #{eligibility.auction_id} (their highest win in
                  this group).
                </p>

                <div className="wallet-remarks-section">
                  <label className="wallet-form-label">{i18n.t('remarks')}</label>
                  <textarea
                    value={remarks}
                    onChange={(e) => this.setState({ remarks: e.target.value })}
                    rows={3}
                    className="wallet-textarea"
                    placeholder="Optional note"
                  />
                </div>
              </div>

              <div className="wallet-actions">
                <button type="button" className="modal-btn btn-cancel" onClick={onClose}>
                  {i18n.t('cancel')}
                </button>
                <button
                  type="button"
                  className="modal-btn btn-confirm"
                  onClick={this.handleSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <span style={{ color: 'white', display: 'flex', alignItems: 'center', gap: 5 }}>
                      <Loader2 className="animate-spin" size={16} /> Applying...
                    </span>
                  ) : (
                    'Apply Discount'
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </CustomModal>
    );
  }
}